import { render, staticRenderFns } from "./RedirectButton.vue?vue&type=template&id=cf055e7a&scoped=true&"
import script from "./RedirectButton.vue?vue&type=script&lang=js&"
export * from "./RedirectButton.vue?vue&type=script&lang=js&"
import style0 from "./RedirectButton.vue?vue&type=style&index=0&id=cf055e7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf055e7a",
  null
  
)

export default component.exports